'use client';

import { motion } from 'framer-motion';

export default function Illustration3({ className = '' }: { className?: string }) {

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 273.69 459.39"
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={containerVariants}
        >
            <defs>
                <style>{`.cls-1 { fill: #ffb53e; } .cls-2 { fill: #2283ba; }`}</style>
            </defs>
            <motion.g id="Layer_1-2" data-name="Layer 1" variants={containerVariants}>
                <g>
                    <motion.path
                        variants={itemVariants}
                        className="cls-1"
                        d="M273.62,439.07l-18.35-156.15c-.65-5.54-5.35-9.72-10.92-9.72-.03,0-.06,0-.1,0-33.17.28-63.06,3.94-91.4,11.18l-.5.13-.25.07-.29.07-.49.13-.26.07-.28.07-.48.12-.29.07-.27.07-.5.13-.28.07-.29.07-.5.13-.24.06c-.12.03-.23.06-.33.08l-.48.12-.24.06-.3.07-.48.12-.28.07-.27.07-.5.13-.27.07-.29.07-.49.13-.26.07-.3.07-.48.12-.27.07c-.12.03-.22.05-.31.08l-.47.12-.27.07-.29.07-.48.12-.26.07c-.13.03-.23.06-.33.08l-.47.12-.26.07-.29.07-.5.13-.25.06c-.12.03-.22.05-.31.08l-.48.13-.26.07-.29.07-.49.13-.26.07-.29.07-.49.13-.27.07-.3.07-.48.13-.26.07-.29.07-.49.13-.26.07-.29.07-.49.13-.26.07-.29.07-.49.13-.27.07-.29.07-.48.12-.27.07-.26.06-.51.13-.28.07-.29.07-.49.13-.27.07-.29.07-.51.13-.25.07c-.1.02-.2.05-.3.07l-.47.12-.27.07-.29.07-.49.13-.26.07-.28.07-.5.13-.27.07-.29.07-.51.13-.24.06c-.12.03-.22.05-.31.08l-.47.12-.27.07-.29.07c-45.12,11.5-84.72,31.83-117.68,60.42-2.9,2.52-4.28,6.37-3.64,10.16.65,3.79,3.22,6.97,6.79,8.38l220.31,87.25c1.31.52,2.68.77,4.05.77,1.1,0,2.2-.17,3.25-.49.35-.07.7-.16,1.04-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.04-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.04-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.04-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.04-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.05-.27.35-.07.7-.16,1.04-.27.35-.07.7-.16,1.05-.27,1.61-.33,3.15-1.02,4.5-2.06,3.07-2.36,4.67-6.16,4.22-10.01Z"
                    />
                    <motion.path
                        variants={itemVariants}
                        className="cls-1"
                        d="M57.92,47.16c.53,4.53,3.8,8.26,8.22,9.38,1.61.41,10.07,2.91,18.39,11.87,9.53,10.28,10.31,19.88,10.34,20.29.01.18.03.37.05.55l16.41,135.78,6.11,50.5c.37,3.05,1.99,5.8,4.48,7.6,1.89,1.37,4.15,2.08,6.44,2.08.73,0,1.45-.07,2.18-.22l80.59-16.27c.37-.07.73-.17,1.08-.27.36-.07.71-.16,1.05-.27.36-.07.71-.16,1.05-.27.36-.07.71-.16,1.05-.27.36-.07.7-.16,1.04-.27.36-.07.7-.16,1.04-.27.36-.07.71-.16,1.05-.27.36-.07.71-.16,1.05-.27.36-.07.7-.16,1.04-.27.36-.07.71-.16,1.05-.27.36-.07.71-.16,1.05-.27.35-.07.7-.16,1.04-.27.36-.07.7-.16,1.04-.27.36-.07.71-.16,1.05-.27.36-.07.71-.16,1.05-.27.36-.07.7-.16,1.04-.27.36-.07.7-.16,1.05-.27.36-.07.71-.16,1.05-.27.36-.07.7-.16,1.04-.27.36-.07.71-.16,1.05-.27.36-.07.71-.16,1.05-.27.36-.07.7-.16,1.04-.27.36-.07.7-.16,1.04-.27.36-.07.7-.16,1.04-.27.36-.07.71-.16,1.05-.27.36-.07.7-.16,1.05-.27.36-.07.7-.16,1.04-.27.36-.07.7-.16,1.04-.27,5.6-1.15,9.39-6.38,8.72-12.06l-26.94-229.28c-.61-5.2-4.8-9.25-10.02-9.68L97.97.04c-.3-.02-.61-.04-.91-.04-1.11,0-2.2.17-3.25.49-.35.07-.7.16-1.04.27-.35.07-.7.16-1.05.27-.35.07-.7.16-1.05.27-.35.07-.7.16-1.04.27-.35.07-.7.16-1.05.27-.35.07-.7.16-1.04.27-.35.07-.7.16-1.05.27-.35.07-.7.16-1.05.27-.35.07-.7.16-1.04.27-.35.07-.7.16-1.05.27-.35.07-.7.16-1.05.27-.35.07-.7.16-1.04.27-.35.07-.7.16-1.05.27-2.15.44-4.15,1.52-5.71,3.13-2.29,2.37-3.4,5.65-3.01,8.93l3.15,26.84Z"
                    />
                    <motion.path
                        variants={itemVariants}
                        className="cls-2"
                        d="M212.97,292.23l18.35,156.15L11,361.14c39.45-34.21,81.92-50.1,113.19-58.07,32.91-8.41,63.59-10.62,88.77-10.84Z"
                    />
                    <motion.path
                        variants={itemVariants}
                        className="cls-2"
                        d="M92.58,60.92c12.04,12.97,13.15,25.61,13.25,27,7.51,62.09,15.01,124.19,22.52,186.28l80.59-16.27-26.94-229.28-116.31-9.63,3.15,26.84c1.77.45,13.02,3.49,23.74,15.05Z"
                    />
                </g>
            </motion.g>
        </motion.svg>
    );
}
